import { render, staticRenderFns } from "./BS46Alert.vue?vue&type=template&id=0fe41233"
import script from "./BS46Alert.vue?vue&type=script&lang=js"
export * from "./BS46Alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports